export default __webpack_public_path__ + "static/media/clouds.e3f8e105.png";